import { useDrawer } from 'context/TaskDrawerContext/DrawerContext'
import { useMemo } from 'react'
import RowDrawer from './RowDrawer'
import { OrgRow, Row } from './taskTypes'

export default function RowDrawerWrapper({
  rows,
  orgRows,
  onUpdateProd,
  onUpdateOrg,
  denseInput,
  extraFields = [
    { key: 'text1', label: 'text1' },
    { key: 'text2', label: 'text2' },
    { key: 'text3', label: 'text3' },
    { key: 'text4', label: 'text4' },
  ] as const,
  buildTaskName,
  containerEl,
  drawerWidth,
}: {
  rows: Row[]
  orgRows: OrgRow[]
  onUpdateProd: (idx: number, patch: Partial<Row>) => void
  onUpdateOrg: (idx: number, patch: Partial<OrgRow>) => void
  denseInput: any
  extraFields?: readonly { key: keyof Row; label: string }[]
  buildTaskName?: (
    _orgName: string,
    taskType: string,
    taskTypeLabel: string,
    _platform?: string,
    _channel?: string
  ) => string
  containerEl?: HTMLElement | null
  drawerWidth?: number
}) {
  const { sel, open, closeDrawer, select } = useDrawer()
  const kind = sel?.kind ?? 'prod'
  const idx = sel?.idx ?? -1
  const name = useMemo(() => {
    if (!rows || !orgRows) return null
    return kind === 'prod' && rows[idx]
      ? buildTaskName(rows[idx]?.org?.name, rows[idx]?.taskType, rows[idx]?.taskTypeLabel)
      : kind === 'org'
      ? buildTaskName(orgRows[idx]?.org?.name, orgRows[idx]?.taskType, orgRows[idx]?.taskTypeLabel)
      : null
  }, [rows, orgRows])

  const row =
    kind === 'prod' ? { ...rows[idx], kind: 'prod', name: name } : { ...orgRows[idx], kind: 'org', name: name } // If selected index drifted out of range, close
  if (open && ((kind === 'prod' && idx >= rows.length) || (kind === 'org' && idx >= orgRows.length))) {
    closeDrawer()
  }

  const handleUpdate = (patch: any) => {
    if (sel == null) return
    if (sel.kind === 'prod') onUpdateProd(sel.idx, patch)
    else onUpdateOrg(sel.idx, patch)
  }

  return (
    <RowDrawer
      key={`${kind}-${idx}-${(row as any)?.SK ?? (row as any)?.id ?? 'new'}`}
      open={open}
      onClose={closeDrawer}
      row={row as Row}
      onUpdate={handleUpdate}
      denseInputSx={denseInput}
      extraFields={extraFields}
      containerEl={containerEl}
      drawerWidth={drawerWidth}
      // Extra header with product and org selection from radios
      // headerExtras={<HeaderExtras rows={rows} orgRows={orgRows} idx={idx} kind={kind} select={select} />}
    />
  )
}
